import { LitElement, html, css, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { msg, localized } from "@lit/localize";

declare global {
  interface HTMLElementTagNameMap {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    "web-kiosk-countdown-box": WebKioskCountdownBoxElement;
  }
}

@localized()
@customElement("web-kiosk-countdown-box")
export class WebKioskCountdownBoxElement extends LitElement {
  @property({ type: Number }) countdownNumber = 60;

  render(): TemplateResult {
    return html` <div class="counter-box">
      <p class="counter-box-body">
        <span class="counter-number">${this.countdownNumber}</span>
        <br />
        ${msg("seconds", { desc: "seconds label" })}
      </p>
    </div>`;
  }

  static styles = css`
    :host {
      --wh-kiosk-counter-box-background-color: #fff;
    }

    .counter-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 auto 48px;
      border-radius: 10px;
      background-color: var(--wh-kiosk-counter-box-background-color, hotpink);
      border: 3px solid var(--wh-palette-colors-brand-red, hotpink);
      width: 186px;
    }

    .counter-box-body {
      color: var(--wh-palette-colors-gray5, hotpink);
      font-size: 26px;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
    }

    .counter-number {
      color: var(--wh-palette-colors-navy, hotpink);
      font-size: 88px;
      font-weight: 600;
      line-height: 88px;
      text-align: center;
    }
  `;
}
